export default "__VITE_ASSET___799770Y__"